import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filterProducts',
    standalone: false
})
export class FilterProductsPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
        if(it.id){
            if(it.description){
                if(it.title){
                    return it.title.toLowerCase().includes(searchText) || it.id.toLowerCase().includes(searchText) || it.description.toLowerCase().includes(searchText);
                }else{
                    return it.id.toLowerCase().includes(searchText) || it.description.toLowerCase().includes(searchText);
                }
            }else{
                if(it.title){
                    return it.title.toLowerCase().includes(searchText) || it.id.toLowerCase().includes(searchText);
                }else{
                    return it.id.toLowerCase().includes(searchText);
                }
            }
        }else
            return ""

    });
   }
}